import { push } from "connected-react-router";
import * as FullStory from "@fullstory/browser";

import handleResponse from "../../shared/handleResponse";
import { ENTRYPOINT_PATH } from "../../routing/paths";
import {
  setToken,
  setStatus,
  setInvocations,
  setPublisher,
  changePath,
} from "../Wizard/actions";
import { logEvent } from "../../shared/eventLogger";

type AuthenticationProps = {
  uuid: string;
  status: string;
  invocations: object;
  publisher: object;
};
const authenticateSuccess = (dispatch: Function) => ({
  uuid,
  status,
  invocations,
  publisher,
}: AuthenticationProps) => {
  FullStory.identify(uuid);
  logEvent("login", { method: "token", value: uuid });
  localStorage.setItem("token", uuid);
  dispatch(setToken(uuid));
  dispatch(setStatus(status));
  dispatch(setInvocations(invocations));
  dispatch(setPublisher(publisher));

  const path = localStorage.getItem("path");
  if (path) {
    dispatch(push(path));
  } else {
    localStorage.setItem("path", ENTRYPOINT_PATH);
    dispatch(push(ENTRYPOINT_PATH));
  }
};

const redirect = () => async (dispatch: Function) => {
  const path = localStorage.getItem("path");
  if (path) dispatch(push(path));
  else dispatch(changePath(ENTRYPOINT_PATH));
};

const createWizard = (url: string) => async (dispatch: Function) => {
  type WizardProps = {
    uuid: string;
    status: string;
    invocations: object;
    publisher: object;
  };
  const onSuccess = ({ uuid, status, invocations, publisher }: WizardProps) => {
    FullStory.identify(uuid);
    logEvent("new_wizard", { value: uuid });
    localStorage.setItem("token", uuid);
    dispatch(setToken(uuid));
    dispatch(setStatus(status));
    dispatch(setInvocations(invocations));
    dispatch(setPublisher(publisher));
    dispatch(redirect());
  };

  await handleResponse(
    "post",
    "/wizards",
    onSuccess,
    dispatch,
    { url },
    { Authorization: process.env.REACT_APP_CORE_API_AUTH_TOKEN },
  );
};

export const authenticate = (url?: string) => async (dispatch: Function) => {
  const token = localStorage.getItem("token");
  if (token) {
    const onSuccess = authenticateSuccess(dispatch);
    await handleResponse("post", "/sessions", onSuccess, dispatch, { url });
  } else {
    await createWizard(window.location.hostname)(dispatch);
  }
};

const cancelSuccess = () => {
  logEvent("clear_wizard", {});
  localStorage.clear();
  window.location.href = "/";
};

export const cancelWizard = () => async (dispatch: Function) => {
  await handleResponse("post", "/wizards/cancel", cancelSuccess, dispatch);
};
